import { Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomKeyboardComponent } from '@stockcare-components/custom-keyboard/custom-keyboard.component';
import { KeyboardTemplate } from '@stockcare-components/custom-keyboard/keyboard-templates';
import { AuthenticationService } from '@stockcare-services/authentication/authentication.service';

@Component({
  standalone: false,
	selector: 'app-pin-dialog',
	templateUrl: './pin-dialog.component.html',
	styleUrls: ['./pin-dialog.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class PinDialogComponent {
	@ViewChild('pinKeyboard') pinKeyboard: CustomKeyboardComponent;
	public userName: string;
	public pin: string = '';
	public placeholderText: string = 'enter pin';
	public wrongPin: boolean = false;

	public keyboardTemplate = KeyboardTemplate.Pin;

	constructor(
		private authService: AuthenticationService,
		private dialogRef: MatDialogRef<PinDialogComponent>,
		@Inject(MAT_DIALOG_DATA) data
	) {
		this.userName = data.userName;
	}

	public typedText(text: string): void {
		this.wrongPin = false;
		if (!text) this.placeholderText = 'enter pin';

		this.pin = text;
		const pinLength: number = 4;
		text?.length === pinLength && this.validatePin(this.userName, this.pin);
	}

	validatePin(userName: string, pin: string): void {
		this.authService.loginWithPin(userName, pin).subscribe((isValidPin) => {
			if (isValidPin) {
				this.dialogRef.close();
			} else {
				this.pinKeyboard.clearValue();
				this.pin = '';
				this.placeholderText = 'invalid pin';
				this.wrongPin = true;
			}
		});
	}
}
